import { isStr, isFn, isObj, isDef } from 'istp';
export var propertyDecorator = wrappedDecorate(isPropertyDecorator);
export var classDecorator = wrappedDecorate(isClassDecorator);
export function isPropertyDecorator(args) {
  return args.length === 3 && // 2 in TS for target ES3 but we do not support it
  isObj(args[0]) && isStr(args[1]) && (isObj(args[2]) || !isDef(args[2])) // undefined in TS for target >= ES5
  ;
}
export function isClassDecorator(args) {
  return args.length === 1 && isFn(args[0]);
}

function wrappedDecorate(isWithNoArgs) {
  return function (decorator) {
    return function () {
      var args = arguments;

      if (isWithNoArgs(args)) {
        return decorator.apply(undefined, args);
      }

      return function () {
        var _ref;

        var extraArgs = Array.prototype.slice.call(args);

        var allArgs = (_ref = []).concat.apply(_ref, Array.prototype.slice.call(arguments).concat([extraArgs]));

        return decorator.apply(undefined, allArgs);
      };
    };
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/decorating/index.esm.js
// module id = 137
// module chunks = 0